/**
 * Agent Panel - slide-in drawer that hosts the Agent Library/Builder/Sandbox
 * over the workflow canvas, so agents can be browsed, created, edited, and
 * tested without leaving the workflow.
 */

import React from 'react';
import type { AgentConfig } from '../types/agent';
import type { ConnectedInputInfo, UpstreamStep } from '../utils/outputPath';
import { AgentLibrary } from './AgentLibrary';
import './AgentPanel.css';

interface AgentPanelProps {
  initialMode?: 'library' | 'edit' | 'sandbox';
  initialAgentId?: string;
  selectedAgentId?: string;
  onSelectAgent: (agent: AgentConfig) => void;
  onAgentUpdated?: (agent: AgentConfig) => void;
  onClose: () => void;
  upstreamSteps?: UpstreamStep[];
  connectedInputs?: ConnectedInputInfo[];
}

export const AgentPanel: React.FC<AgentPanelProps> = ({
  initialMode,
  initialAgentId,
  selectedAgentId,
  onSelectAgent,
  onAgentUpdated,
  onClose,
  upstreamSteps,
  connectedInputs,
}) => {
  return (
    <div className="agent-panel-backdrop" onClick={onClose}>
      <div className="agent-panel" onClick={(e) => e.stopPropagation()}>
        <div className="agent-panel-header">
          <button className="agent-panel-close" onClick={onClose} title="Close">
            ×
          </button>
        </div>
        <div className="agent-panel-content">
          <AgentLibrary
            initialMode={initialMode}
            initialAgentId={initialAgentId}
            selectedAgentId={selectedAgentId}
            onSelectAgent={onSelectAgent}
            onAgentUpdated={onAgentUpdated}
            upstreamSteps={upstreamSteps}
            connectedInputs={connectedInputs}
          />
        </div>
      </div>
    </div>
  );
};
